module.exports = __webpack_public_path__ + "img/lunbotu.e036b90e.png";